import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsComponent } from './notifications/notifications.component';
import { SettingsComponent } from './settings.component';
import { LanguageComponent } from './language/language.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ThresholdComponent } from './threshold/threshold.component';
import { GeographicalZoneListComponent } from './geographical-zone-list/geographical-zone-list.component';
import { FaqListComponent } from "./faq/faq-list.component";

export const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path: '',
        redirectTo: 'notifications',
        pathMatch: 'full'
      },
      // {
      //   path:'threshold',
      //   component:ThresholdComponent,
      //   data:{
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Threshold', iconType: 'MAT', icon: 'insert_chart_outlined'},
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      // {
      //   path:'notifications',
      //   component:NotificationsComponent,
      //   data:{
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Notifications', iconType: 'MAT', icon: 'notifications'},
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      // {
      //   path:'language',
      //   component:LanguageComponent,
      //   data:{
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Language & Units', iconType: 'MAT', icon: 'language'},
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      // {
      //   path:'maintenance',
      //   component:MaintenanceComponent,
      //   data:{
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Maintenance', iconType: 'MAT', icon: 'settings'},
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      // {
      //   path:'geographical-zone',
      //   component:GeographicalZoneListComponent,
      //   data:{
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Geographical Zones', iconType: 'MAT', icon: 'location_on'},
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      {
        path: 'faqs',
        component: FaqListComponent,
        data: {
          parentTitlePath: null,
          menu: { title: 'FAQ', iconType: 'MAT', icon: 'help_outline' },
          permissions: {
            only: ['can_configure_settings'],
            redirectTo: ['not-allowed']
          },
        }
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
